import { render } from "./product-list-model.vue?vue&type=template&id=3c55c116"
import script from "./product-list-model.vue?vue&type=script&lang=js"
export * from "./product-list-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__